import React from 'react';
import styled from 'styled-components';
import {SIZES} from '@fupa/fupa-uikit';
import {TopelevenPlayer} from 'app/components/topEleven/TopElevenPlayer';
import {array} from 'prop-types';

const LineUpContainer = styled.div`
  width: inherit;
  max-width: 27.75rem;
`;

const Goalkeeper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const Players = styled.div`
  display: flex;
  width: 100%;

  & > div {
    flex: 1 33%;
  }
`;

const CenterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  height: 100%;
`;

const CenterBackground = styled.div`
  width: ${SIZES['80']};
  height: ${SIZES['80']};
  background-color: #ffd200;
  border-radius: ${SIZES['40']};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TopElevenTeam = ({topeleven}) => {
  const goalkeeper = topeleven
    .filter((player) => player.position === 'Torwart')
    .map((player) => <TopelevenPlayer key={player.player.slug} player={player} />);
  const defense = topeleven
    .filter((player) => player.position === 'Abwehr')
    .map((player) => <TopelevenPlayer key={player.player.slug} player={player} />);
  const midfield = topeleven.filter((player) => player.position === 'Mittelfeld');
  const defensiveMid = (
    <Players>
      <TopelevenPlayer player={midfield[2]} />
      <CenterContainer>
        <CenterBackground>
          <img src='interwetten.svg' height={36} alt='Interwetten-Logo' />
        </CenterBackground>
      </CenterContainer>
      <TopelevenPlayer player={midfield[3]} />
    </Players>
  );
  const offensiveMid = midfield
    .slice(0, 2)
    .map((player) => <TopelevenPlayer key={player.player.slug} player={player} />);
  const attack = topeleven
    .filter((player) => player.position === 'Angriff')
    .map((player) => <TopelevenPlayer key={player.player.slug} player={player} />);

  return (
    <LineUpContainer>
      <Players>{attack}</Players>
      <Players>{offensiveMid}</Players>
      <Players>{defensiveMid}</Players>
      <Players>{defense}</Players>
      <Goalkeeper>{goalkeeper}</Goalkeeper>
    </LineUpContainer>
  );
};

TopElevenTeam.propTypes = {
  topeleven: array.isRequired,
};

export {TopElevenTeam};
